import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../shared.module';
import { MessageModule } from '../../message/message.module';
import { SupportPageComponent } from './support-page.component';
import { PoSearchComponent } from './po-search/po-search.component';
import { SupportFormComponent } from './support-form/support-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MessageModule,
    SharedModule,
  ],
  declarations: [
    SupportPageComponent,
    PoSearchComponent,
    SupportFormComponent,
  ],
  exports: [
    SupportPageComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class SupportPageModule {}
